/**
 * ResizeHandle — drag handle 6px dán mép phải header cell.
 * Dùng kèm `useColumnWidths` để resize cột trong TableVirtuoso pattern.
 */
import { Box } from '@mui/material'
import type { MouseEvent as ReactMouseEvent } from 'react'

interface Props {
  onMouseDown: (event: ReactMouseEvent<HTMLDivElement>) => void
}

export function ResizeHandle({ onMouseDown }: Props) {
  return (
    <Box
      onMouseDown={onMouseDown}
      onClick={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
      aria-hidden
      sx={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: 6,
        cursor: 'col-resize',
        zIndex: 2,
        userSelect: 'none',
        '&:hover': {
          backgroundColor: (t) => t.palette.primary.main,
          opacity: 0.4,
        },
        '&:active': {
          backgroundColor: (t) => t.palette.primary.main,
          opacity: 0.7,
        },
      }}
    />
  )
}

export default ResizeHandle
